import { h, Component } from "preact";
import { Router, route } from "preact-router";

import Header from "./header";
import { isLoggedIn, getGender, setGender, syncLocalStorage, logout } from "./authstore";
import Home from "../routes/home";
import Login from "../routes/login";
import Register from "../routes/register";
import Reset from "../routes/reset";
import ResetExec from "../routes/resetexec";
import Profile from "../routes/profile";
import Wizard from "../routes/wizard";
import Editor from "../routes/editor";
import Dash from "../routes/dash";
import Week from "../routes/week";
import Print from "../routes/print";
// import Home from 'async!./home';
// import Profile from 'async!./profile';

class AuthenticatedRoute extends Component {
  componentWillMount() {
    let { check } = this.props;
    this.allowed = check();
    // console.log("gender auth", this.props.gender);
    if (!this.allowed) route("/" + this.props.gender);
  }
  render({ check, route: Route, ...props }) {
    return <div>{this.allowed && <Route {...props} />}</div>;
  }
}

export default class App extends Component {
  state = { userLoggedIn: false, showHeader: true };

  /** Gets fired when the route changes.
   *	@param {Object} event		"change" event from [preact-router](http://git.io/preact-router)
   *	@param {string} event.url	The newly routed URL
   */
  handleRoute = e => {
    this.currentUrl = e.url;
    const status = isLoggedIn();
    let gender = getGender();
    

    // console.log("e", e);
    // console.log("url", e.url);
    if (e.url.includes("women")) gender = "women";
    else if (e.url.includes("men")) gender = "men";

    this.setState({ userLoggedIn: status }); // required for header logged in status
    setGender(gender);
    this.setState({ gender });

    if (
      e.url === "/" ||
      e.url === "/women" ||
      e.url === "/men" ||
      e.url === "/women/" ||
      e.url === "/men/"
    ) {
      // console.log("!! home route detected (in handle route)");
      if (status) {
        // console.log("!! already logged in");
        route("/" + gender + "/dash");
      }
    }

    if (
      e.url === "/" ||
      e.url === "/women" ||
      e.url === "/men" ||
      e.url === "/women/" ||
      e.url === "/men/" ||
      e.url.indexOf("/women/re") >= 0 ||
      e.url.indexOf("/men/re") >= 0 ||
      e.url.indexOf("/women/pa") >= 0 ||
      e.url.indexOf("/men/pa") >= 0 
    ) {
      this.setState({ showHeader: false });
    } else {
      this.setState({ showHeader: true });
    }

    // console.log("running route update in handleRoute");
  };

  componentWillMount() {
    const status = isLoggedIn();
    const gender = getGender();

    this.setState({ userLoggedIn: status }); // required for header logged in status
    this.setState({ gender }); // required for header gender CSS
    if (status) {
      // if logged in locally, run sync
      syncLocalStorage(e => {
        // console.log("data synced: ", e);
        if (e === 401) {
          // wrong credentials
          // console.log("logging out locally because of 401");
          logout(gender);
        }
      });
    }
  }

  componentDidMount() {
    let notify = true;

    if (!!window.Notification) {
      console.log("Notification API supported");
    } else {
      notify = false;
    }

    if (notify === true) {
      console.log("Notification.permission", Notification.permission);
      if (Notification.permission == "default") {
        Notification.requestPermission(function(result) {
          console.log("Notification request", result);
        });
      }
    }
  }

  // https://github.com/developit/preact-router

  render({}, { userLoggedIn, gender, showHeader }) {
    return (
      <div id="app" {...gender === "women" && { class: "women" }}>
        <Header check={userLoggedIn} gender={gender} showHeader={showHeader}/>
        <Router onChange={this.handleRoute}>
          <Home path="/" default gender="women" />
          <Login path="/men" gender="men" />
          <Login path="/women" gender="women" />
          <Register path="/men/register" token="" email="" gender="men" />
          <Register path="/men/register/:token/:email" gender="men" />
          <Register path="/women/register" token="" email="" gender="women" />
          <Register path="/women/register/:token/:email" gender="women" />
          <Reset path="/men/reset" gender="men" />
          <Reset path="/women/reset" gender="women" />
          <ResetExec path="/men/password-reset" token="" gender="men" />
          <ResetExec path="/men/password-reset/:token" gender="men" />
          <ResetExec path="/women/password-reset" token="" gender="women" />
          <ResetExec path="/women/password-reset/:token" gender="women" />

          <AuthenticatedRoute
            path="/men/wizard/:step"
            check={isLoggedIn}
            route={Wizard}
            gender="men"
          />
          <AuthenticatedRoute
            path="/men/editor/:workout"
            check={isLoggedIn}
            route={Editor}
            gender="men"
          />
          <AuthenticatedRoute path="/men/dash/" check={isLoggedIn} route={Dash} gender="men" />
          <AuthenticatedRoute
            path="/men/week/"
            week=""
            workout=""
            exercise=""
            check={isLoggedIn}
            route={Week}
            gender="men"
          />
          <AuthenticatedRoute
            path="/men/week/:week"
            workout=""
            exercise=""
            check={isLoggedIn}
            route={Week}
            gender="men"
          />
          <AuthenticatedRoute
            path="/men/week/:week/:workout"
            exercise=""
            check={isLoggedIn}
            route={Week}
            gender="men"
          />
          <AuthenticatedRoute
            path="/men/week/:week/:workout/:exercise"
            check={isLoggedIn}
            route={Week}
            gender="men"
          />

          <AuthenticatedRoute path="/men/print" check={isLoggedIn} route={Print} gender="men" />

          <AuthenticatedRoute
            path="/women/wizard/:step"
            check={isLoggedIn}
            route={Wizard}
            gender="women"
          />
          <AuthenticatedRoute
            path="/women/editor/:workout"
            check={isLoggedIn}
            route={Editor}
            gender="women"
          />
          <AuthenticatedRoute path="/women/dash/" check={isLoggedIn} route={Dash} gender="women" />
          <AuthenticatedRoute
            path="/women/week/"
            week=""
            workout=""
            exercise=""
            check={isLoggedIn}
            route={Week}
            gender="women"
          />
          <AuthenticatedRoute
            path="/women/week/:week"
            workout=""
            exercise=""
            check={isLoggedIn}
            route={Week}
            gender="women"
          />
          <AuthenticatedRoute
            path="/women/week/:week/:workout"
            exercise=""
            check={isLoggedIn}
            route={Week}
            gender="women"
          />
          <AuthenticatedRoute
            path="/women/week/:week/:workout/:exercise"
            check={isLoggedIn}
            route={Week}
            gender="women"
          />

          <AuthenticatedRoute path="/women/print" check={isLoggedIn} route={Print} gender="women" />

          <Profile path="/profile/" user="me" />
          <Profile path="/profile/:user" />
          {/*
					<Wizard path="/wizard/:step" />
					<Editor path="/editor/:workout" />
					<Dash path="/dash/" />
					<Week path="/week/" week="" workout="" exercise="" />
					<Week path="/week/:week" workout="" exercise="" />
					<Week path="/week/:week/:workout" exercise="" />
					<Week path="/week/:week/:workout/:exercise" /> */}
        </Router>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/app.js